<template>
    <div>
        <div
        @click.prevent="openShare"
        class="press-item__share"
        >
            Поделиться статьёй
            <div id="news-share" class="ya-share2" data-curtain data-limit="0" data-more-button-type="short" data-services="vkontakte,odnoklassniki,moimir"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pressShare",
        setup() {
            const openShare = () => {
                setTimeout(() => {
                    document.querySelector('.ya-share2__popup').classList.add('ya-share2__popup_visible');
                }, 100)
            };

            return {
                openShare
            };
        },
    }
</script>
